import { combineReducers } from "redux";
import withBgReducers from "./withBgReducers";
// import withBgReducers from "./userReducer";

const rootReducer = combineReducers({
    Data3D: withBgReducers,
    // Data2D: withBgReducers,
});

export default rootReducer;
